import { Navigate, useLocation } from "react-router-dom";

function PublicRoute({ children }) {
  const location = useLocation();

  try {
    const rawUser = localStorage.getItem("user");
    if (!rawUser) return children;

    const user = JSON.parse(rawUser);
    if (!user || !user.id) return children;

    if (!user.profilePicture && location.pathname === "/profile-picture") {
      return children;
    }

    return (
      <Navigate
        to={user.profilePicture ? "/dashboard" : "/profile-picture"}
        replace
      />
    );
  } catch (error) {
    return children;
  }
}

export default PublicRoute;
